import request from '@/utils/request'

export function login(data) {
  return request({ url: '/admin/auth/login', method: 'post', data })
}

export function getInfo() {
  return request({ url: '/admin/auth/info', method: 'get' })
}

export function getDashboard() {
  return request({ url: '/admin/statistics/dashboard', method: 'get' })
}

export function getOrderList(params) {
  return request({ url: '/admin/order/list', method: 'get', params })
}

export function getUserList(params) {
  return request({ url: '/admin/user/list', method: 'get', params })
}

export function getDriverList(params) {
  return request({ url: '/admin/driver/list', method: 'get', params })
}

export function auditDriver(data) {
  return request({ url: '/admin/driver/audit', method: 'post', data })
}

export function getStationList() {
  return request({ url: '/admin/station/list', method: 'get' })
}

export function saveStation(data) {
  return request({ url: '/admin/station/save', method: 'post', data })
}

export function deleteStation(data) {
  return request({ url: '/admin/station/delete', method: 'post', data })
}

export function getPointList(params) {
  return request({ url: '/admin/station/pointList', method: 'get', params })
}

export function savePoint(data) {
  return request({ url: '/admin/station/pointSave', method: 'post', data })
}

export function deletePoint(data) {
  return request({ url: '/admin/station/pointDelete', method: 'post', data })
}

export function getComplaintList(params) {
  return request({ url: '/admin/complaint/list', method: 'get', params })
}

export function handleComplaint(data) {
  return request({ url: '/admin/complaint/handle', method: 'post', data })
}

export function getLogList(params) {
  return request({ url: '/admin/system/logList', method: 'get', params })
}

export function getConfigList() {
  return request({ url: '/admin/system/configList', method: 'get' })
}

export function saveConfig(data) {
  return request({ url: '/admin/system/configSave', method: 'post', data })
}

export function getAdminList() {
  return request({ url: '/admin/system/adminList', method: 'get' })
}

export function saveAdmin(data) {
  return request({ url: '/admin/system/adminSave', method: 'post', data })
}

export function getRoleList() {
  return request({ url: '/admin/system/roleList', method: 'get' })
}

export function saveRole(data) {
  return request({ url: '/admin/system/roleSave', method: 'post', data })
}

export function getPermissionList() {
  return request({ url: '/admin/system/permissionList', method: 'get' })
}

export function savePermission(data) {
  return request({ url: '/admin/system/permissionSave', method: 'post', data })
}

export function getRefundList(params) {
  return request({ url: '/admin/order/refundList', method: 'get', params })
}

export function setUserStatus(data) {
  return request({ url: '/admin/user/setStatus', method: 'post', data })
}

export function setDriverStatus(data) {
  return request({ url: '/admin/driver/setStatus', method: 'post', data })
}

export function getOrderDetail(params) {
  return request({ url: '/admin/order/detail', method: 'get', params })
}

export function getWithdrawList(params) {
  return request({ url: '/admin/withdraw/list', method: 'get', params })
}

export function auditWithdraw(data) {
  return request({ url: '/admin/withdraw/audit', method: 'post', data })
}

export function getBannerList() {
  return request({ url: '/admin/content/bannerList', method: 'get' })
}

export function saveBanner(data) {
  return request({ url: '/admin/content/bannerSave', method: 'post', data })
}

export function deleteBanner(data) {
  return request({ url: '/admin/content/bannerDelete', method: 'post', data })
}

export function getHotRouteList() {
  return request({ url: '/admin/content/hotRouteList', method: 'get' })
}

export function saveHotRoute(data) {
  return request({ url: '/admin/content/hotRouteSave', method: 'post', data })
}

export function deleteHotRoute(data) {
  return request({ url: '/admin/content/hotRouteDelete', method: 'post', data })
}

export function getTripList(params) {
  return request({ url: '/admin/trip/list', method: 'get', params })
}

export function cancelTrip(data) {
  return request({ url: '/admin/trip/cancel', method: 'post', data })
}

export function uploadImage(data) {
  return request({ url: '/admin/upload/image', method: 'post', data })
}
